import { render } from "./MobMenu.vue?vue&type=template&id=2c68926a"
import script from "./MobMenu.vue?vue&type=script&lang=js"
export * from "./MobMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__